import React from 'react';
import { IconContextProvider } from '@splunk/visualization-context/IconContext';
import IconRegistry from '@splunk/visualization-context/IconRegistry';
import MockedProvider from '@splunk/visualization-context/MockedProvider';
import SingleValueIcon from '@splunk/dashboard-visualizations/SingleValueIcon';

const iconRegistry = IconRegistry.create();
const mockedProvider = new MockedProvider();
iconRegistry.addProvider(mockedProvider);
mockedProvider.upload('https://upload.wikimedia.org/wikipedia/commons/3/36/Ladder_%28example%29.svg');

export default () => (
    <IconContextProvider value={iconRegistry}>
        <SingleValueIcon
            options={{
                icon: 'mock://0',
            }}
            encoding={{}}
            dataSources={{
                primary: {
                    data: {
                        columns: [
                            ['1', '62', '103', '308', '587', '876', '930', '1320'],
                            [
                                '2018-08-19T00:00:00.000+00:00',
                                '2018-08-20T00:00:00.000+00:00',
                                '2018-08-21T00:00:00.000+00:00',
                                '2018-08-22T00:00:00.000+00:00',
                                '2018-08-23T00:00:00.000+00:00',
                                '2018-08-24T00:00:00.000+00:00',
                                '2018-08-25T00:00:00.000+00:00',
                                '2018-08-26T00:00:00.000+00:00',
                            ],
                        ],
                        fields: [
                            {
                                name: 'foo',
                            },
                            {
                                name: '_time',
                            },
                        ],
                    },
                    meta: {},
                },
            }}
        />
    </IconContextProvider>
);
